@if (componentData.product$ | async) {
  @if (thumbs$ | async; as thumbs) {
    @if (!thumbs.length) {
      @if (mainImage$ | async; as main) {
        <div (click)="showZoomImage(false, main)">
          <boels-media
            [container]="main"
            [alt]="main.product?.altText"
            [sizes]="
              '(min-width: 576px) 333px, ' +
              '(min-width: 992px) 444px, ' +
              '250px'
            "
          ></boels-media>
        </div>
      }
    }
    @if (thumbs.length) {
      <boels-carousel
        class="thumbs"
        [items]="thumbs"
        itemWidth="100%"
        [hideIndicators]="false"
        [template]="thumb"
        [indicatorIcon]="faCircle"
      ></boels-carousel>
    }
  }
}

<ng-template #thumb let-item="item">
  <div (click)="showZoomImage(true, null, item.container.zoom.galleryIndex)">
    <boels-media
      [container]="item.container"
      tabindex="0"
      [class.is-active]="isActive(item.container) | async"
      class="product-image-carousel"
      [sizes]="'(min-width: 576px) 330px, ' + '190px'"
    >
    </boels-media>
  </div>
</ng-template>
